import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import TechStaffing from "@/pages/TechStaffing";
import GeneralStaffing from "@/pages/GeneralStaffing";
import HealthcareStaffing from "@/pages/HealthcareStaffing";
import RPO from "@/pages/RPO";
import EOR from "@/pages/EOR";
import ForEmployers from "@/pages/ForEmployers";
import ForCandidates from "@/pages/ForCandidates";
import Resources from "@/pages/Resources";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import CookiePolicy from "@/pages/CookiePolicy";
import NotFound from "@/pages/NotFound";
import CookieBanner from "@/components/CookieBanner";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-[color:var(--canvas-light)]">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/technology-staffing" element={<TechStaffing />} />
            <Route path="/general-staffing" element={<GeneralStaffing />} />
            <Route path="/healthcare-staffing" element={<HealthcareStaffing />} />
            <Route path="/rpo" element={<RPO />} />
            <Route path="/eor" element={<EOR />} />
            <Route path="/for-employers" element={<ForEmployers />} />
            <Route path="/for-candidates" element={<ForCandidates />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
        <Toaster position="top-right" richColors closeButton />
      </div>
    </BrowserRouter>
  );
}

export default App;
